import React, { useState } from 'react';
import '../Styles/awards.css';
import TextBlur from '../Components/TextBlur';

const Awards = () => {
  const [visibleElement, setVisibleElement] = useState(null);

  const handleSetVisibleElement = (element) => {
    setVisibleElement(element);
  };
  return (
    <section id='awards-section' className="grid grid-3 padding-100">
      <TextBlur
        text="Cantor campeão do Live Fest"
        setVisibleElement={handleSetVisibleElement}
        isVisible={visibleElement?.innerText === "Cantor campeão do Live Fest"}
      />
      <TextBlur
        text="Campeão em Tiktok Live Brasil 2024"
        setVisibleElement={handleSetVisibleElement}
        isVisible={visibleElement?.innerText === "Campeão em Tiktok Live Brasil 2024"}
      />
      <TextBlur
        text="Campeão em Tiktok Live Brasil 2023"
        setVisibleElement={handleSetVisibleElement}
        isVisible={visibleElement?.innerText === "Campeão em Tiktok Live Brasil 2023"}
      />
    </section>
  );
};

export default Awards;
